import { HttpError } from "react-admin";

const ADMIN_ROLE = 'winco';
const SERVICE_ROLE = 'service';
const SERVICE_ADMIN_ROLE = 'serviceadmin';

export const authProvider = {
  login: ({ username, password }) => {
    const request = new Request(
      `${process.env.REACT_APP_API_URL}/auth`,
      {
        method: 'POST',
        body: JSON.stringify({ username, password }),
        headers: new Headers({ 'Content-Type': 'application/json' }),
      }
    );
    return fetch(request)
      .then(response => {
        if (response.status === 401) {
          throw new HttpError(
            'Credenciales inválidas',
            response.status,
            {
              message: 'El usuario o contraseña son incorrectos. Por favor, verifica tus datos.'
            }
          );
        }
        if (response.status === 404) {
          throw new HttpError(
            'Servicio no disponible',
            response.status,
            {
              message: 'No se puede conectar con el servidor. Por favor, intenta más tarde.'
            }
          );
        }
        if (response.status < 200 || response.status >= 300) {
          throw new HttpError(
            'Error de autenticación',
            response.status,
            {
              message: 'Ha ocurrido un error durante la autenticación. Por favor, intenta nuevamente.'
            }
          );
        }
        return response.json();
      })
      .then(auth => {
        if (!auth.user || !auth.user.role) {
          throw new HttpError(
            'Error de datos',
            400,
            {
              message: 'Los datos del usuario son inválidos.'
            }
          );
        }
        if (![ADMIN_ROLE, SERVICE_ROLE, SERVICE_ADMIN_ROLE].includes(auth.user.role)) {
          throw new HttpError(
            'Acceso denegado',
            403,
            {
              message: 'No tienes los permisos necesarios para acceder al panel administrativo.'
            }
          );
        }
        localStorage.setItem("user", JSON.stringify(auth.user));
        localStorage.setItem("token", auth.token);
        localStorage.setItem("permissions", JSON.stringify(auth.user.role));
        localStorage.setItem("role", auth.user.role);
        localStorage.setItem("email", auth.user.email || auth.user.username);
      })
      .catch(error => {
        if (error instanceof HttpError) {
          throw error;
        }
        throw new HttpError(
          'Error de conexión',
          500,
          {
            message: 'Ha ocurrido un error al conectar con el servidor. Por favor, verifica tu conexión a internet.'
          }
        );
      });
  },
  logout: () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    return Promise.resolve();
  },
  checkError: error => Promise.resolve(),
  checkAuth: () =>
    localStorage.getItem("token") ? Promise.resolve() : Promise.reject(),
  getPermissions: () => {
    const permissions = localStorage.getItem("permissions");
    return permissions ? Promise.resolve(JSON.parse(permissions)) : Promise.reject();
  },
  getIdentity: () => {
    const persistedUser = localStorage.getItem("user");
    return persistedUser ? Promise.resolve(JSON.parse(persistedUser)) : Promise.reject();
  },
};
